import React, { useState } from "react";
import { MenuOutlined } from "@ant-design/icons";
import Logo from "../Logo/Logo";
import HeaderCategories from "../HeaderCategories/HeaderCategories";
import UserInfo from "../UserInfo/UserInfo";
import MobileMenu from "../MobileMenu/MobileMenu";
import { useNavigate } from "react-router-dom";
import "./Header.css";

function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const isLoggedIn = false;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const navigate = useNavigate();

  return (
    <div className="header-container">
      <div className="header-section">
        <div className="burger-menu-icon" onClick={toggleMobileMenu}>
          <MenuOutlined />
        </div>
        <div className="header-logo-position">
          <Logo />
          <div className="header-categories">
            <HeaderCategories />
          </div>
        </div>
        <div className="user-container">
          <UserInfo />
        </div>
        {/* Mobile sign-in button - only visible on small screens */}
        <div className="mobile-signin">
          <span className="signin-user" onClick={() => navigate("/signin")}>
            Sign In
          </span>
        </div>
      </div>
      <MobileMenu isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} isLoggedIn={isLoggedIn} />
    </div>
  );
}

export default Header;